// This plugin is used on Fund's edit page, specifically for Holdings.
// It's based on the other symbol_autocomplete.js file, but aimed to be a
// jQuery plugin and not to depend on #ids. It uses data-behavior and data-role
// attributes to find each element. That way, it can be used multiple times
// in the same page.
(function($){
  $.fn.handleSymbolAutocomplete = function() {
    return this.each(function(){
      var $element = $(this);

      var resultsDiv = $element.find('[data-role=ticker-matches]');

      var showTickerInput = function() {
        clearCompanyInfo();
        $element.find('[data-role=name-and-exchange]').show().find('input, select').prop('disabled', false);
      }

      var clearCompanyInfo = function(){
        $element.find('[data-role=name-and-exchange] input').val('');
        $element.find('[data-role=company-info]').html('').hide();
        $element.find('[data-role=company-id-input]').val('');
        $element.find('[data-role=company-autocomplete-id-input]').val('');
      }

      var showCompanyInfo = function(div, field) {
        if(div.data('ticker')) {
          $element.find('[data-role=name-and-exchange]').hide().find('input, select').prop('disabled', true);
          $element.find('[data-role=company-info]').html("<strong>" + div.data('name') + "</strong>").show();
          $element.find('[data-role=company-id-input]').val('');
          $element.find('[data-role=company-autocomplete-id-input]').val(div.data('id'));
          if(field){
            field.val(div.data('ticker'));
          }
        } else if(! $element.find('[data-role=company-id-input]').val() ) {
          // show ticker only if company was modified
          showTickerInput();
        }
      }

      var requestSymbols = function(value){
        $.ajax({
          url: '/pro/autocomplete/symbol',
          data: { query: value, asset_type: $element.find("[data-role=asset-class-input]").val() },
          dataType: 'html',
          success: function(response) {
            // Hide results if empty or if input is not currently focused
            if(($.trim(response).length === 0))  {
              resultsDiv.hide();
            } else {
              resultsDiv.html(response).show();



              // Auto-highlight the first result unless the only option is "New Ticker"
              var $firstResult = resultsDiv.find('li').first();
              if ($firstResult.attr('id') !== 'new-ticker'){
                $firstResult.addClass('selected');
              }

              // If there is *only one* exact matching ticker then show it and hide the ticker input fields
              var exactMatch = resultsDiv.find('.exact-match');
              if(exactMatch.length === 1) {
                showCompanyInfo(exactMatch);
                if(resultsDiv.find('li:not(.exact-match)').length === 0 &&
                                  exactMatch.data('ticker') === value ){
                  resultsDiv.hide();
                $autocompleteInput.trigger('selected.autocomplete')
                }
              }
              // Mark current hover li as selected. It will really be seleted on blur (happening on click or enter)
              resultsDiv.on('mouseenter', 'li', function() {
                resultsDiv.find('li').removeClass('selected');
                $(this).addClass('selected');
              });

              resultsDiv.on('click', 'li', function(event){
                event.preventDefault();
                event.stopPropagation();
                var $company = $(this);
                showCompanyInfo($company, $autocompleteInput);
                $autocompleteInput.trigger('selected.autocomplete');
                resultsDiv.hide();
              });
              // Clicking anywhere else on the screen closes the results
              $('html').one('click', function() { resultsDiv.hide(); });
            }
          }
        })
      }

      var previousVal = '';
      var $autocompleteInput = $element.find("[data-behavior~=symbol-autocomplete]");
      var debouncedCheckValue =  _.debounce(function(currentVal){
        requestSymbols(currentVal);
      }, 500);

      $autocompleteInput.on('keyup', function(event){
        var keycode = event.keyCode || event.which;
        var currentVal = $autocompleteInput.val()
        if (currentVal === '') {
          return resultsDiv.hide();
        }
        // Show loading indicator if keypress isn't up/down/enter or if input isn't empty/same as before.
        if ((currentVal !== previousVal) && (keycode !== 37 && keycode !== 38  && keycode !== 39 && keycode !== 40 && keycode !== 13)) {
          previousVal = currentVal;
          resultsDiv.html('<span class="loading-autocomplete"> <i class="ico-spinner"> </i>Loading...</span>').show();
          debouncedCheckValue(currentVal);
        }
      }).on('keydown', function(event) {
        var keycode = event.keyCode || event.which;
        if(keycode == 13) {
          // Prevent form submit on press enter
          event.preventDefault();
          event.stopPropagation();
          var selectedItems = resultsDiv.find('.selected');
          if (selectedItems.length) {
            var $this = $(this)
            var $company = selectedItems.first();
            showCompanyInfo($company, $this);
            $this.trigger('selected.autocomplete');
            resultsDiv.hide();
          }
          // hack the tab functionality
          // $element.find('input:visible, select:visible').not(this).first().focus();
        } else if (keycode === 40) { // Down arrow
          var selectedItem = resultsDiv.find('li.selected:first')
          if (selectedItem.length === 0) {
            selectedItem = resultsDiv.find('li:first').addClass('selected');
          } else {
            selectedItem.removeClass('selected');
            if (selectedItem.next().length > 0) {
              selectedItem = selectedItem.next().addClass('selected');
            } else {
              // Jump to the next category and select the first item
              selectedItem
                .parent('ul')
                .nextAll('ul')
                .first()
                .find('li:first')
                .addClass('selected')
            }
            
          }
        } else if (keycode === 38) { // Up Arrow
          if (resultsDiv.find('li.selected').length > 0) {
            var selectedItem = resultsDiv.find('li.selected:first')
            if (selectedItem.length === 0) {
              selectedItem = resultsDiv.find('li:first').addClass('selected');
            } else {
              selectedItem.removeClass('selected');
              if (selectedItem.prev().length > 0) {
                selectedItem.prev().addClass('selected');
              } else {
                // Jump to the previous category and select the last item
                selectedItem
                  .parent('ul')
                  .prevAll('ul')
                  .first()
                  .find('li:last')
                  .addClass('selected')
              }
              
            }
          }
        } else if (keycode === 9){
          resultsDiv.hide();
        } else { 
          clearCompanyInfo();
        }
        return true;
      });

    });

  }
})(jQuery);


// Initialize plugin

$(function(){
  $('.js-autocomplete-form').handleSymbolAutocomplete();  
});

